var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.384,
    height: 155.858,
    viewBox: "0 0 200.384 155.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f3f5f9;}.b{fill:#d8e0ea;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.716 -69.472)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.716 81.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M167.624,5.477C160.758.806,146-1.588,137.682,1.17,127.064,4.7,127.437,12.432,119.71,17.219c-20.873,12.919-42.061,4.232-64.119-1.332C6.709,3.537-23.9,50.571,24.1,79.487,52.971,96.864,113.59,109.561,120.416,63.5c2.953-19.913-7.7-21.428,17.053-25.758C147.24,36.023,198.728,26.648,167.624,5.477Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 24.665, 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.592,76.392a43.415,43.415,0,1,1,6.1,61.095A43.415,43.415,0,0,1,191.592,76.392Zm64.448,52.741a39.862,39.862,0,1,0-56.1,5.609A39.862,39.862,0,0,0,256.04,129.133Z",
    transform: "translate(-75.033 9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M352.736,214.276c4.277,2.554,8.345,5.36,12.342,8.256s7.892,5.911,11.724,9.006,7.594,6.28,11.222,9.624q2.727,2.5,5.329,5.143c1.741,1.776,3.451,3.553,5.063,5.48a2.5,2.5,0,0,1-3.109,3.8c-2.221-1.2-4.3-2.522-6.373-3.877s-4.1-2.767-6.1-4.219c-4-2.9-7.865-5.946-11.653-9.1s-7.519-6.368-11.147-9.717-7.186-6.777-10.534-10.463a2.571,2.571,0,0,1,3.224-3.939Z",
    transform: "translate(-167.897 -76.295)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.934 215.275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 86.106,
    cy: 5.027,
    rx: 86.106,
    ry: 5.027
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.304 132.709)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M199.289,224.916h0a5.64,5.64,0,0,1,5.2-3.7h35.55A4.2,4.2,0,0,1,244.357,226l-9.184,77.056a5.587,5.587,0,0,1-5.449,4.765h-112.8a4.192,4.192,0,0,1-4.312-4.765l7.7-64.741a5.587,5.587,0,0,1,5.449-4.765h61.383A13.176,13.176,0,0,0,199.289,224.916Z",
    transform: "translate(-98.866 -220.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M117.23,308.977H235.1l6.715-79.307H123.949Z",
    transform: "translate(-101.456 -224.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M117.23,308.977H235.1l4.858-79.307H123.949Z",
    transform: "translate(-101.456 -224.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M117.23,305.825H235.1L239.148,224H121.285Z",
    transform: "translate(-101.456 -221.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M117.23,305.825H235.1L236.7,224H121.285Z",
    transform: "translate(-101.456 -221.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M117.23,303.046H235.1L235.8,219H117.936Z",
    transform: "translate(-101.456 -219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M115.157,305.036H233.025L230.6,222.58H113.5Z",
    transform: "translate(-99.383 -220.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M112.855,305.825H230.723L227.224,224H109.36Z",
    transform: "translate(-97.082 -221.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M110.259,307.371H228.127l-5.573-80.591H104.69Z",
    transform: "translate(-94.486 -223.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M109.147,308.232H227.015l-6.462-79.9H102.69Z",
    transform: "translate(-93.374 -224.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M156.511,236.073h0a3.842,3.842,0,0,1,4.019-3.788h35.55a6.217,6.217,0,0,1,5.835,4.885l14.047,71.944a3.908,3.908,0,0,1-3.93,4.885H99.231a6.216,6.216,0,0,1-5.84-4.885L81.8,249.8a3.908,3.908,0,0,1,3.93-4.885h61.388C152.452,244.919,156.329,241.251,156.511,236.073Z",
    transform: "translate(-81.712 -226.383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFile);
export default __webpack_public_path__ + "static/media/search_file.34b74342a6502ab30a9e0a03379a8886.svg";
export { ForwardRef as ReactComponent };